<template>
    <div>
        <div id="preloader">
            <div data-loader="circle-side"></div>
        </div>

        <div id="loader_form">
            <div data-loader="circle-side-2"></div>
        </div>

        <nav>
            <ul class="cd-primary-nav" @click="logPostData">
            </ul>
        </nav>

        <div class="container-fluid full-height">
            <div class="row row-height">

                <!-- Blue (left/top) Side -->
                <div class="d-none d-md-block col col-lg-6 content-left">
                    <div class="content-left-wrapper">
                        <a :href="homeLink()" id="logo"><img :src="s3asset('img/logo/white_icon.png', false)" alt="" height="44"/></a>

                        <div v-if="show_instructions" style="width: 80%; overflow: hidden;">
                            <InstructionsCarousel/>
                        </div>

                        <div v-else-if="step === 'send_options'">
                            <div class="pip">
                                <img class="splash-preview pip-property" :src="pip_large" alt="Property"/>
                                <img class="splash-preview pip-review" :src="pip_small" alt="Review" @click="toggleFocusedImage"/>
                            </div>
                        </div>

                        <div v-else-if="step === 'include_notecard'" style="display: flex; flex-direction: column; align-items: center; text-wrap: balance;">
                            <div v-if="listing_details.selected_property_type === 'listed'">
                                <h4 style="color: white; max-width: 100%">Would You Like to Thank Your Home Seller?</h4>
                                <p style="max-width: 100%;">
                                    If you want to send a quick handwritten notecard to your home seller that will include your
                                    info and headshot and link to your Zillow profile for a review this is where you do it.
                                </p>
                                <div style="width: 60%; margin: 0 auto;">
                                    <img :src="s3asset('img/examples/listed-notecard.png', false)" alt="Listed Notecard Message" style="width: 100%;"/>
                                </div>
                            </div>
                            <div v-else-if="listing_details.selected_property_type === 'sold'">
                                <h4 style="color: white; max-width: 100%">Would You Like to Thank Your Home Seller?</h4>
                                <p style="max-width: 100%;">
                                    If you want to send a quick handwritten notecard to your home seller that will include your
                                    info and headshot and link to your Zillow profile for a review this is where you do it.
                                </p>
                                <div style="width: 60%; margin: 0 auto;">
                                    <img :src="s3asset('img/examples/sold-notecard.png', false)" alt="Sold Notecard Message" style="width: 100%;"/>
                                </div>
                            </div>
                            <div v-else>
                                <h4 style="color: white; max-width: 100%">Add A Follow-Up Handwritten Notecard</h4>
                                <p style="max-width: 100%;">
                                    Dramatically increase your conversion rate by sending a second touch. Our handwritten note card comes complete with first class mail a real life stamp and an envelope.
                                </p>
                                <div style="width: 60%; margin: 0 auto;">
                                    <img :src="s3asset('img/examples/lead-notecard.png', false)" alt="Sold Notecard Message" style="width: 100%;"/>
                                </div>
                            </div>
                            <p class="mt-4">Please note: The actual card will have your info.</p>
                        </div>

                        <div v-else-if="step === 'property_preview'" class="w-100">
                            <div v-if="listing_details.selected_property_type === 'leads'">
                                <div style="color: white !important; margin-bottom: 1rem;">
                                    <div id="preview_container" class="postcard-preview" :style="card_leads_styles">
                                        <div v-if="property_rendering " class="property-preview-loading">
                                        <span style="color: #434bdf; position: absolute; font-size: 1.25rem; font-weight: 600; top: 10%; text-wrap: balance;">
                                            <span v-if="downloading_property_data">Searching The Internet For Your Listing Data<br><span style="color: grey; font-size: 1rem;"> (please be patient this could take up to a minute)</span> </span>
                                        </span>
                                            <img :src="s3asset('img/jljs-loading.gif', false)" alt="Loading..." style="width: 100%;"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <h5 style="color: white;">Pick Any of Our High Converting Templates</h5>
                                </div>
                                <div class="row">
                                    <div class="templates" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; flex-basis: max(100%, 200px); column-gap: .5rem;">
                                        <div class="template" @click="selected_lead_template = 1">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/leads-1.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/leads-1.png', true)" alt="LEADS_1" loading="lazy" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                        <div class="template" @click="selected_lead_template = 2">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/leads-2.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/leads-2.png', true)" alt="LEADS_2" loading="lazy" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                        <div class="template" @click="selected_lead_template = 3">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/leads-3.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/leads-3.png', true)" alt="LEADS_3" loading="lazy" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div style="color: white !important; margin-bottom: 1rem;">
                                    <div id="preview_container" class="postcard-preview" :style="card_property_styles">
                                        <div v-if="property_rendering " class="property-preview-loading">
                                        <span style="color: #434bdf; position: absolute; font-size: 1.25rem; font-weight: 600; top: 10%; text-wrap: balance;">
                                            <span v-if="downloading_property_data">Searching The Internet For Your Listing Data<br><span style="color: grey; font-size: 1rem;"> (please be patient this could take up to a minute)</span> </span>
                                        </span>
                                            <img :src="s3asset('img/jljs-loading.gif')" alt="Loading..." style="width: 100%;"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <h5 style="color: white;">Pick Any of Our High Converting Templates</h5>
                                </div>
                                <div class="row">
                                    <div v-if="listing_details.selected_property_type === 'listed'" class="templates" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; flex-basis: max(100%, 200px); column-gap: .5rem;">
                                        <div class="template" @click="selected_property_template = 1">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/listed-1-min.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/listed-1.png', true)" alt="LISTED_1" loading="lazy" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                        <div class="template" @click="selected_property_template = 2">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/listed-2-min.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/listed-2.png', true)" alt="LISTED_2" loading="lazy" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                        <div class="template" @click="selected_property_template = 3">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/listed-3-min.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/listed-3.png', true)" alt="LISTED_3" loading="lazy" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else class="templates" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; flex-basis: max(100%, 200px); column-gap: .5rem;">
                                        <div class="template" @click="selected_property_template = 1">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/sold-1-min.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/sold-1.png', true)" alt="SOLD_1" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                        <div class="template" @click="selected_property_template = 2">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/sold-2-min.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/sold-2.png', true)" alt="SOLD_2" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                        <div class="template" @click="selected_property_template = 3">
                                            <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/sold-3-min.png', true) + ')'}">
                                                <img :src="s3asset('img/examples/sold-3.png', true)" alt="SOLD_3" @load="showLoadedImage"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="listing_details.selected_property_type === 'listed'" class="row mt-2">
                                    <h5 style="color: white;">
                                        We also have <span class="clickable" style="text-decoration: underline;" @click="selected_property_template = 4">Open House</span>, <span class="clickable" style="text-decoration: underline;" @click="selected_property_template = 5">Under Contract</span>, and <span class="clickable" style="text-decoration: underline;" @click="selected_property_template = 6">Coming Soon</span> templates.
                                    </h5>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="step === 'review_preview' || step === 'qr_code'" class="w-100">
                            <div style="color: white !important;">
                                <div id="preview_container" class="postcard-preview" :style="card_review_styles">
                                    <div style="aspect-ratio: 9/6; width: 100%"></div>

                                    <div v-if="property_rendering " class="property-preview-loading">
                                        <img :src="s3asset('img/jljs-loading.gif', false)" alt="Loading..." style="width: 100%;"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="w-100">
                            <div style="margin-bottom: 3rem;">
                                <h3 style="color: white;">Looking To Automate Direct Mail?</h3>
                                <h5 style="color: white;">
                                    Our parent company <a href="https://www.thanks.io" style="color: white;" target="_blank">www.thanks.io</a> can automate the sending
                                    of postcards, notecards, letters, and gift cards from your favorite CRM.
                                </h5>
                                <a href="https://thanks.io" class="btn btn-warning">
                                    Click to Get $10 in Free Credits
                                </a>
                            </div>
                        </div>

                        <div class="copy">© JustListedJustSold.com {{ year }} | <a style="color: white;" href="/terms" target="_blank"> Privacy Policy & TOS </a></div>
                    </div>
                </div>

                <!-- White (right/bottom) Side -->
                <div class="col-lg-6 content-right" id="start" style="padding: 60px 60px 20px; flex-direction: column; height: unset; overflow-y: unset;">
                    <div id="wizard_container">
                        <form id="wrapped" method="POST" action="/checkout">

                            <input type="hidden" name="_token" :value="csrf">
                            <input id="website" name="website" type="text" value="">
                            <input type="hidden" name="post_data" :value="post_data"/>

                            <div id="middle-wizard">
                                <div id="template_select" class="step centered template_select" data-step="template_select" >
                                    <div class="row">
                                        <div class="col col-12 text-center d-none d-md-block">
                                            <img :src="s3asset('img/logo/jljs-thanks-logo.png', true)" alt="Just List Just Sold Postcards" style="height: 60px; margin-bottom: 30px;"/>
                                        </div>
                                        <div class="col col-12 text-center d-block d-md-none">
                                            <img :src="s3asset('img/logo/jljs-thanks-logo.png', true)" alt="Just List Just Sold Postcards" style="height: 35px; margin-bottom: 30px;"/>
                                        </div>
                                    </div>

                                    <h6 >
                                        <span class="d-none d-sm-block">Please Select Your Preferred Template</span>
                                        <span class="d-sm-none">Select Your Preferred Template</span>
                                    </h6>

                                    <p>
                                        Just <strong>${{ lowest_price }}</strong> cents per High Converting 6x9 Postcard with Built In QR Tracking & Custom Targeting Options (includes printing and postage)
                                    </p>

                                    <div id="template-group" class="templates">
                                        <template-row template_type="listed" title="Just Listed" :whitelabel="whitelabel" @thumbnail-clicked="goToPropertyEditor" ></template-row>

                                        <div class="row pt-3">
                                            <span>
                                                We also have <span class="clickable" style="text-decoration: underline;" @click="goToPropertyEditor('listed', 4);">Open House</span>, <span class="clickable" style="text-decoration: underline;" @click="goToPropertyEditor('listed', 5);">Under Contract</span>, and <span class="clickable" style="text-decoration: underline;" @click="goToPropertyEditor('listed', 6);">Coming Soon</span> templates.
                                            </span>
                                        </div>
                                        <hr>
                                    </div>

                                    <div id="template-group" class="templates">
                                        <template-row template_type="sold" title="Just Sold" :whitelabel="whitelabel" @thumbnail-clicked="goToPropertyEditor"></template-row>
                                        <hr>
                                    </div>

                                    <div id="template-group" class="templates">
                                        <template-row template_type="leads" title="Seller Farming" :whitelabel="whitelabel" @thumbnail-clicked="goToPropertyEditor"></template-row>
                                    </div>

                                </div>

                                <div class="step centered" data-step="agent_search" id="agent_search">
                                    <div class="row mb-4">
                                        <div class="col col-12 text-center d-none d-md-block">
                                            <img :src="s3asset('img/logo/jljs-thanks-logo.png', true)" alt="Just List Just Sold Postcards" style="height: 60px;"/>
                                        </div>
                                        <div class="col col-12 text-center d-block d-md-none">
                                            <img :src="s3asset('img/logo/jljs-thanks-logo.png', true)" alt="Just List Just Sold Postcards" style="height: 35px;"/>
                                        </div>
                                    </div>
                                    <div v-if="enter_zillow_url">
                                        <zillow-profile-search
                                                   :initial_profile_url="user.profile_url"
                                                   @form-submitted="createOrLoginUserViaZillowUrl"
                                                ></zillow-profile-search>
                                         <button type="button" name="backward" class="backward" @click="enter_zillow_url=false">Back</button>
                                    </div>
                                    <div v-else>
                                        <div class="row mb-2">
                                            <div class="col col-10 text-end">
                                                <a href="javascript:void(0);" @click="enter_zillow_url = true">Enter Zillow URL Manually</a>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col col-2">
                                                        <span class="review-side-label">Name</span>
                                                    </div>
                                                    <div class="col col-8 position-relative">
                                                        <input id="agent_search_name" type="text" name="agent" class="form-control" placeholder="e.g. John Doe" v-model="user.name" required>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col col-2">
                                                        <span class="review-side-label">State</span>
                                                    </div>
                                                    <div class="col col-8">
                                                        <div class="review-select-dropdown">
                                                            <v-select :options="states" v-model="user.state" label="name" :reduce="name => name.name" placeholder="Select State">
                                                                <template #search="{attributes, events}">
                                                                    <input
                                                                        class="vs__search"
                                                                        :required="!user.state"
                                                                        v-bind="attributes"
                                                                        v-on="events"
                                                                        autocomplete="state"
                                                                    />
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col offset-2 col-2">
                                                    <button type="button" name="backward" class="_backward" @click="backward">Back</button>
                                                </div>
                                                <div class="col offset-1 col-5">
                                                    <button type="button" name="forward" class="_forward w-100" @click="createOrLoginUser">Find My Listings</button>
                                                </div>
                                            </div>
                                            <div class="row" style="margin-top: 30px;">
                                                <div class="col offset-2 col-8">
                                                    <p>
                                                        Once you click the button we will merge your listing data with our high converting just listed/sold & seller farming templates. Customize as needed and launch your campaign in under 3 minutes. If we can't find your data, we will go back to manual input.
                                                    </p>
                                                    <p>
                                                        <u>Get more listings with <em><strong>almost</strong></em> zero work.</u>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="property_select" class="step centered property-step" data-step="property_select">
                                    <div v-if="zillow_profile_error" class="alert alert-danger">
                                        <strong>Oops!</strong> There was a problem loading your Zillow profile.
                                        Please check your Zillow profile URL and try again. If you continue to have issues please come back later.
                                    </div>
                                    <div v-if="zillow_data_loading" id="finding-profile">
                                        <div>
                                            <h3>Please watch a short tutorial while we find your listings</h3>
                                        </div>
                                        <div>
                                            <img :src="s3asset('img/JLJSVideo-optimize.gif', false)" alt="Loading..." style="width: 100%"/>
                                        </div>
                                    </div>
                                    <div v-else id="zillow_profiles">
                                        <div class="agent-section d-flex mb-5">
                                            <div v-if="!incorrect_user" class="agent-display w-100" style="display: flex; justify-content: space-between; align-items: center; padding: 0 1rem;">
                                                <div class="agent-info" style="display: flex; flex-direction: row; align-items: center; height: 100px;">
                                                    <img :src="user.profile_image_url" style="height: 100px; border-radius: 50%;">
                                                    <div style="display: flex; flex-direction: column; justify-content: end; margin-left: 1rem; height: 100%;">
                                                        <div style="font-size: 1.25rem; font-weight: 500; margin-bottom: 5px;">{{ user.name }}</div>
                                                        <div style="font-size: 1rem; margin-bottom: 5px;">{{ user.company }}</div>
                                                        <a href="javascript:void(0);" @click="incorrect_user = true;">Don't See Your Listings?</a>
                                                    </div>
                                                </div>
                                                <div class="clickable d-none d-sm-block" style="display: flex; flex-direction: row; align-items: end; margin-left: auto;" @click="selectProperty({}, 'leads')">
                                                    <div style="display: flex; flex-direction: column; justify-content: end; align-items: end; margin-right: 1rem; height: 100%;">
                                                        <div style="font-size: 1.25rem; font-weight: 500; margin-bottom: 5px;">Need Listings?</div>
                                                        <a href="javascript:void(0);" style="font-size: 1rem;">Try Seller Lead Farming</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="agent-form w-100" style="min-height: 100px;">
                                                <zillow-profile-search
                                                   :initial_profile_url="user.profile_url"
                                                   @form-submitted="createOrLoginUserViaZillowUrl"
                                                ></zillow-profile-search>
                                            </div>
                                        </div>
                                        <div class="property-select">
                                            <div class="property-group">
                                                <h4 style="font-size: 1rem;">JUST LISTED</h4>
                                                <div class="property-card clickable" v-if="for_sale_listings.length > 0" v-for="property in for_sale_listings" @click="selectProperty(property, 'listed')">
                                                    <div class="property-image d-lg-none d-xl-block" :style="{backgroundImage: 'url(' + checkPropertyImage(property.image_thumbnail_url) + ')'}"></div>
                                                    <div class="property-description">
                                                        <div class="property-street">{{ property.address_line1 }}</div>
                                                        <div>{{ property.address_line2 }}</div>
                                                    </div>
                                                </div>
                                                <div class="property-card" v-else>
                                                    <div style="text-align: center; width: 100%;"><i class="icon-warning" style="margin-right: 5px;"/>No Properties Found</div>
                                                </div>
                                                <div class="property-card clickable" @click="selectProperty({}, 'listed')">
                                                    <div class="property-image d-lg-none d-xl-block" :style="{backgroundImage: 'url(' + s3asset('img/property-thumbnail.jpg', false) + ')'}"></div>
                                                    <div class="property-description">
                                                        <div class="property-street">New Just Listed Property</div>
                                                        <div>Create a Just Listed postcard from scratch</div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="property-group">
                                                <h4 style="font-size: 1rem;">JUST SOLD</h4>
                                                <div class="property-card clickable" v-if="sold_listings.length > 0" v-for="property in sold_listings" @click="selectProperty(property, 'sold')">
                                                    <div class="property-image d-lg-none d-xl-block" :style="{backgroundImage: 'url(' + checkPropertyImage(property.image_thumbnail_url) + ')'}"></div>
                                                    <div class="property-description">
                                                        <span class="property-street">{{ property.address_line1 }}</span>
                                                        <span>{{ property.address_line2 }}</span>
                                                    </div>
                                                </div>
                                                <div class="property-card" v-else>
                                                    <div style="text-align: center; width: 100%;"><i class="icon-warning" style="margin-right: 5px;"/>No Properties Found</div>
                                                </div>
                                                <div class="property-card clickable" @click="selectProperty({}, 'sold')">
                                                    <div class="property-image d-lg-none d-xl-block" :style="{backgroundImage: 'url(' + s3asset('img/property-thumbnail.jpg', false) + ')'}"></div>
                                                    <div class="property-description">
                                                        <div class="property-street">New Just Sold Property</div>
                                                        <div>Create a Just Sold postcard from scratch</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="step-action-group">
                                        <button type="button" name="backward" class="_backward" @click="backward">Back</button>

                                    </div>
                                </div>

                                <div class="step" data-step="property_preview" id="property_preview">
                                    <div v-if="listing_details.selected_property_type === 'leads'" class="leads-form">
                                        <h3>Front of the 6"x9" Postcard</h3>
                                        <p>
                                            Most of these fields will be prefilled and you can choose one of our proven
                                            templates on the left. Don't worry about fitting all your text on the front, the back will
                                            contain your contact info & disclaimers.
                                        </p>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Neighborhood Center</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <google-autocomplete autocomplete="off"
                                                                         id="address-line1"
                                                                         name="address-line1"
                                                                         placeholder="Street Address ex: 123 Main St, Anytown NY 55555"
                                                                         v-model="listing_details.address.line_1"
                                                                         class="form-control"
                                                                         :value="listing_details.address.line_1"
                                                                         @input="autocompleteInput"
                                                                         :require_notecard_address="true"
                                                                         @changed="onPropertyAddressInput"
                                                    />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col offset-3 col-8">
                                                    <p class="mb-0 mt-2">Please enter the FULL mailing address at the center of where you would like to farm leads.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Agent</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <input type="text" name="name" class="form-control" placeholder="Agent Name" v-model="user.name" required  @change="renderPropertySide">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Headshot</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <input type="file" name="property_image" id="property_image_file" ref="agentHeadshot" class="form-control" placeholder="Headshot Image" accept="image/png, image/jpeg" @change="uploadHeadshotImage" style="display:none;">

                                                    <label for="property_image_file" class="review-side-label">
                                                        <div class="input-group">
                                                            <div class="input-group-addon input-group-text">Choose File </div>
                                                            <input readonly class="form-control" style="backgroundColor: #FFFFFF;"  type="text" accept="image/png, image/jpeg" :value="agent_photo_filename">
                                                        </div>
                                                    </label>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Background</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <input type="file" name="leads_image" id="leads_image_file" ref="leadsImage" class="form-control" placeholder="Property Image" accept="image/png, image/jpeg" @change="uploadLeadsImage" style="display:none;">

                                                    <label for="leads_image_file" class="review-side-label">
                                                        <div class="input-group">
                                                            <div class="input-group-addon input-group-text">Choose File </div>
                                                            <input readonly class="form-control" style="backgroundColor: #FFFFFF;"  type="text" accept="image/png, image/jpeg" :value="leads_image_filename">
                                                        </div>
                                                    </label>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="step-action-group">
                                            <button type="button" name="backward" class="_backward" @click="backwardFromEditor">Back</button>
                                            <button id="property_next" type="button" name="forward" class="_forward" style="margin-left: auto;" @click="confirmLeadsPreview" :disabled="leads_side_incomplete">{{ leads_render_status }}</button>
                                        </div>

                                        <div class="d-sm-block d-md-none mt-5" style="margin-left: -60px; margin-right: -60px; padding: 1rem;">
                                            <div style="color: white !important; padding-bottom: .5rem;">
                                                <div id="preview_container" class="postcard-preview" :style="card_leads_styles">
                                                    <div v-if="property_rendering " class="property-preview-loading">
                                                        <img :src="s3asset('img/jljs-loading.gif', false)" alt="Loading..." style="width: 100%;"/>
                                                        <span style="color: #434bdf; position: absolute; font-size: 1rem; font-weight: 600; top: 80%; text-wrap: balance;">Please allow up to 1 minute to render your preview...</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" style="justify-content: center; margin: 0; padding: unset;">
                                                <div class="templates" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; min-width: unset; max-width: unset; column-gap: .5rem; padding: unset;">
                                                    <div class="template" @click="selected_property_template = 1">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/leads-1.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/leads-1.png', true)" alt="LEADS_1" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                    <div class="template" @click="selected_property_template = 2">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/leads-2.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/leads-2.png', true)" alt="LEADS_2" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                    <div class="template" @click="selected_property_template = 3">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/leads-3.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/leads-3.png', true)" alt="LEADS_3" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="property-inputs">
                                        <div class="row pb-3">
                                            <div class="col-7">
                                                <h3>Front of the 6"x9" Postcard</h3>
                                            </div>
                                            <div class="col text-end">
                                                <button type="button" class="_backward bg-success text-white" @click="loadFromMLS">Load From MLS</button>
                                            </div>
                                        </div>
                                        <div v-if="zillow_profile_error" class="d-sm-block mt-2">
                                            <div class="alert alert-danger text-center">
                                                <strong>Unable to find your listing data. </strong> Please search again with your Zillow URL or set the listing data manually below.
                                            </div>
                                        </div>

                                        <p>
                                            If you choose the <strong>"Load from MLS"</strong> option, most of these fields will be prefilled and you can choose one of our proven templates on the left. Don't worry about fitting all your text on the front, the back will contain your contact info & disclaimers.
                                        </p>

                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Agent</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <input type="text" name="name" class="form-control" placeholder="Agent Name" v-model="user.name" required  @change="renderPropertySide">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Address</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <google-autocomplete autocomplete="off"
                                                                         id="address-line1"
                                                                         name="address-line1"
                                                                         placeholder="Street Address ex: 123 Main St, Anytown NY 55555"
                                                                         v-model="listing_details.address.line_1"
                                                                         class="form-control"
                                                                         :value="listing_details.address.line_1"
                                                                         @input="listing_details.address.line_1 = $event.target.value"
                                                                         :require_notecard_address="true"
                                                                         @changed="onPropertyAddressInput"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3"></div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <input type="text" name="address-line2" autocomplete="off" class="form-control" placeholder="City, State ZIP ex: Anytown, US 12345" v-model="listing_details.address.line_2" required @change="onPropertyAddressInput()" readonly>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Header</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <input type="text" name="property_description" class="form-control" placeholder="Example: 3 Beds, 2 Baths, Listed for 500k" v-model="listing_details.description" required @change="renderPropertySide">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">

                                                </div>

                                                <div class="col-sm-12 col-md-8 text-end">
                                                    <div style="display: flex" class="text-end">
                                                        <span  style="margin-right:10px; margin-top: 6px;">Increase Conversion By Hiding Price</span>
                                                        <Toggle v-model="hide_price" id="hide_price" name="hide_price" :onLabel="'Yes'" :offLabel="'No'" class="large-toggle" style="margin-top: auto;" v-on:change="renderPropertySide"> </Toggle>

                                                </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="review-side-label">Image</span>
                                                </div>
                                                <div class="col-sm-12 col-md-8 position-relative">
                                                    <input type="file" name="property_image" id="property_image_file" ref="propertyImage" class="form-control" placeholder="Property Image" accept="image/png, image/jpeg" @change="uploadPropertyImage" style="display:none;">

                                                    <label for="property_image_file" class="review-side-label">
                                                        <div class="input-group">
                                                            <div class="input-group-addon input-group-text">Choose File </div>
                                                            <input readonly class="form-control" style="backgroundColor: #FFFFFF;"  type="text" accept="image/png, image/jpeg" :value="property_image_filename">
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-sm-block d-lg-none mt-5">
                                            <div class="alert alert-warning text-center">
                                                <strong>Heads Up!</strong> The preview (Below) is <strong>EXACTLY</strong> how your postcard will print.
                                            </div>
                                        </div>
                                        <div class="d-lg-block d-none mt-5">
                                            <div class="alert alert-warning text-center">
                                                <strong>Heads Up!</strong> The preview (To the Left) is <strong>EXACTLY</strong> how your postcard will print.
                                            </div>
                                        </div>

                                        <div class="step-action-group">
                                            <button type="button" name="backward" class="_backward" @click="backwardFromEditor">Back</button>
                                            <button id="property_next" type="button" name="forward" class="_forward" style="margin-left: auto;" @click="confirmPropertyPreview" :disabled="property_side_incomplete">{{ property_render_status }}</button>
                                        </div>

                                        <div class="d-sm-block d-md-none mt-5" style="margin-left: -60px; margin-right: -60px; padding: 1rem;">
                                            <div style="color: white !important; padding-bottom: .5rem;">
                                                <div id="preview_container" class="postcard-preview" :style="card_property_styles">
                                                    <div v-if="property_rendering " class="property-preview-loading">
                                                        <img :src="s3asset('img/jljs-loading.gif', false)" alt="Loading..." style="width: 100%;"/>
                                                        <span style="color: #434bdf; position: absolute; font-size: 1rem; font-weight: 600; top: 80%; text-wrap: balance;">Please allow up to 1 minute to render your preview...</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" style="justify-content: center; margin: 0; padding: unset;">
                                                <div v-if="listing_details.selected_property_type === 'listed'" class="templates" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; min-width: unset; max-width: unset; column-gap: .5rem; padding: unset;">
                                                    <div class="template" @click="selected_property_template = 1">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/listed-1-min.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/listed-1.png', true)" alt="LISTED_1" loading="lazy" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                    <div class="template" @click="selected_property_template = 2">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/listed-2-min.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/listed-2.png', true)" alt="LISTED_2" loading="lazy" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                    <div class="template" @click="selected_property_template = 3">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/listed-3-min.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/listed-3.png', true)" alt="LISTED_3" loading="lazy" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else class="templates" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; min-width: unset; max-width: unset; column-gap: .5rem; padding: unset;">
                                                    <div class="template" @click="selected_property_template = 1">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/sold-1-min.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/sold-1.png', true)" alt="SOLD_1" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                    <div class="template" @click="selected_property_template = 2">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/sold-2-min.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/sold-2.png', true)" alt="SOLD_2" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                    <div class="template" @click="selected_property_template = 3">
                                                        <div class="template-image-wrapper" :style="{backgroundImage: 'url(' + s3asset('img/examples/tiny/sold-3-min.png', true) + ')', width: 'unset', filter: 'drop-shadow(0px .1rem .2rem #4F4F4F)'}">
                                                            <img :src="s3asset('img/examples/sold-3.png', true)" alt="SOLD_3" @load="showLoadedImage"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="step" style="padding: 0px" data-step="review_preview">
                                    <h3>Back of the 6"x9" Postcard</h3>
                                    <p>
                                        Most of these fields will be prefilled but you have full control to change any of
                                        them as you see fit.<br>
                                        <u><strong>Please note we will configure the QR in the next step. </strong></u>
                                    </p>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Phone</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input type="text" name="phone" class="form-control" placeholder="Phone" v-model="user.phone" v-on:change="renderReviewSide" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Company</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input name="company" class="form-control" type="text" placeholder="Company" v-model="user.company" v-on:change="renderReviewSide" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Email</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input name="email" class="form-control" type="email" placeholder="Email" v-model="user.email" v-on:change="renderReviewSide" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Testimonial</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 review-select-dropdown">
                                                <v-select :options="reviews" :searchable="false" v-model="selected_review" :placeholder="'Select A Testimonial'" class="review-select">
                                                    <template v-slot:option="option">
                                                        <div class="review-option">
                                                            <div v-if="option.is_custom_message">
                                                                <span>{{ option.name }}</span>
                                                            </div>
                                                            <div v-else>
                                                                <span>{{ option.overall_rating / 100 }} Stars</span>&nbsp;|&nbsp;<span>{{ option.name }}</span>
                                                            </div>
                                                            <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                                {{ option.review_body }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-slot:selected-option="option">
                                                        <div v-if="option.is_custom_message">
                                                            <span>{{ option.name }}</span>
                                                        </div>
                                                        <div v-else>
                                                            <span>{{ option.overall_rating / 100 }} Stars</span>&nbsp;|&nbsp;<span>{{ option.name }}</span>
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="show_custom_message_input" class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Message</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <textarea class="form-control" name="custom_message" v-model="listing_details.custom_message" rows="4" style="height: unset;" placeholder="Write a quick message to your recipients..." v-on:change="renderReviewSide" required></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Call To Action</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input type="text" name="call_to_action" class="form-control" placeholder="Text '123' Main St. to (555) 867-5309 to book viewing." v-model="listing_details.call_to_action" v-on:change="renderReviewSide" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Disclaimer</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input type="text" name="disclaimer" class="form-control" placeholder="Disclaimer" v-model="user.disclaimer" v-on:change="renderReviewSide" required maxlength="190">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Headshot</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input type="file" id="agent_photo" name="agent_image" class="form-control" ref="agentImage" accept="image/png, image/jpeg" @change="uploadAgentImage" style="display:none;">
                                                <label for="agent_photo" class="review-side-label">
                                                    <div class="input-group">
                                                        <div class="input-group-addon input-group-text">Choose File </div>
                                                        <input readonly class="form-control" style="backgroundColor: #FFFFFF;"  type="text" accept="image/png, image/jpeg" :value="agent_photo_filename">
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Primary Logo</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input type="file" id="team_logo" name="team_image" class="form-control" ref="teamImage" accept="image/png, image/jpeg" @change="uploadTeamLogo" style="display:none;">
                                                <label for="team_logo" class="review-side-label">
                                                    <div class="input-group">
                                                        <div class="input-group-addon input-group-text">Choose File </div>
                                                        <input readonly class="form-control" style="backgroundColor: #FFFFFF;" accept="image/png, image/jpeg" type="text" :value="team_logo_filename">
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3">
                                                <span class="review-side-label">Secondary Logo</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 position-relative">
                                                <input type="file" id="broker_logo" name="broker_image" class="form-control" ref="brokerImage" accept="image/png, image/jpeg" @change="uploadBrokerLogo" style="display:none;">
                                                <label for="broker_logo" class="review-side-label">
                                                    <div class="input-group">
                                                        <div class="input-group-addon input-group-text">Choose File </div>
                                                        <input readonly class="form-control" style="backgroundColor: #FFFFFF;" accept="image/png, image/jpeg" type="text" :value="broker_logo_filename">
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="step-action-group">
                                        <button type="button" name="backward" class="_backward" @click="backward">Back</button>
                                        <button id="review_next" type="button" name="review_next" class="_forward" style="margin-left: auto;" @click="recordLead" :disabled="review_side_incomplete">{{ review_render_status }}</button>
                                    </div>
                                    <div class="d-sm-block d-md-none mt-5" style="margin-left: -60px; margin-right: -60px; padding: 1rem;">
                                        <div style="color: white !important;">
                                            <div id="preview_container" class="postcard-preview" :style="card_review_styles">
                                                <div v-if="property_rendering " class="property-preview-loading">
                                                    <img :src="s3asset('img/jljs-loading.gif', false)" alt="Loading..." style="width: 100%;"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="step" data-step="qr_code">
                                    <h3>What happens when someone scans the QR code?</h3>
                                    <p v-if="qr_selected === 'qr_link'">This QR code allows you to open a link when someone scans it with their phone.</p>
                                    <p v-if="qr_selected === 'qr_sms'">This QR code allows you to send a text when someone scans it with their phone.</p>
                                    <p v-if="qr_selected === 'qr_call'">This QR code allows you to make a call when someone scans it with their phone.</p>
                                    <p v-if="qr_selected === 'qr_email'">This QR code allows you to send an email when someone scans it with their phone.</p>

                                    <div class="qr-options">
                                        <div class="qr-option" :class="qr_selected === 'qr_link' ? 'qr-selected' : ''" @click="qr_selected = 'qr_link'">
                                            <span class="qr-label">Link</span>
                                            <img class="qr-image" :src="s3asset('img/qr_options/qr_link.png', false)" alt="Link">
                                        </div>
                                        <div class="qr-option" :class="qr_selected === 'qr_sms' ? 'qr-selected' : ''" @click="qr_selected = 'qr_sms'">
                                            <span class="qr-label">Text</span>
                                            <img class="qr-image" :src="s3asset('img/qr_options/qr_sms.png', false)" alt="SMS">
                                        </div>
                                        <div class="qr-option" :class="qr_selected === 'qr_call' ? 'qr-selected' : ''" @click="qr_selected = 'qr_call'">
                                            <span class="qr-label">Call</span>
                                            <img class="qr-image" :src="s3asset('img/qr_options/qr_call.png', false)" alt="Call">
                                        </div>
                                        <div class="qr-option" :class="qr_selected === 'qr_email' ? 'qr-selected' : ''" @click="qr_selected = 'qr_email'">
                                            <span class="qr-label">Email</span>
                                            <img class="qr-image" :src="s3asset('img/qr_options/qr_email.png', false)" alt="Email">
                                        </div>
                                    </div>

                                    <div v-if="qr_selected === 'qr_link'" id="qr_link">
                                        <div v-if="listing_details.selected_property_type === 'leads'" class="form-group">
                                            <label class="form-label fw-bold" for="qr_link">Qr Code Url</label>
                                            <p style="margin-bottom: 10px;">This link is where you would like people to go when scanning the QR code on your postcard.</p>
                                            <input id="qr_link" type="text" name="qr_link" class="form-control" placeholder="Listing URL" v-model="qr_details.link" required>
                                            <div style="display: flex; flex-direction: row;" class="mt-2">
                                                <div>
                                                    <img :src="s3asset('img/examples/seller-guide-preview.png', false)" alt="Link" style="width: 100px; display: block; margin-left: auto; margin-right: auto;"/>
                                                </div>
                                                <div style="display: flex; flex-direction: column; margin-left: 10px;">
                                                    <p style="margin: 0;">We have automatically built a branded seller guide PDF as the default URL to send people when they scan. Feel free to change this link to your own seller page.</p>
                                                    <a v-if="qr_details.link !== 'SELLERS_GUIDE_PDF'" href="javascript:void(0);" @click="qr_details.link = 'SELLERS_GUIDE_PDF'">Use Branded Seller Guide PDF</a>
                                                    <a v-else href="https://images.bannerbear.com/join_pdfs/vWnx7pMb5lqZJGLVmE/2zW4XVRwgmaRJyKPEY/joined.pdf" target="_blank">Preview Branded Seller Guide PDF</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="form-group">
                                            <label class="form-label fw-bold" for="qr_link">Property Details URL</label>
                                            <p style="margin-bottom: 10px;">This link is where you would like people to go when scanning the QR code on your postcard.</p>
                                            <input id="qr_link" type="text" name="qr_link" class="form-control" placeholder="Listing URL" v-model="qr_details.link" required>
                                        </div>
                                    </div>

                                    <div v-if="qr_selected === 'qr_sms'" id="qr_sms">
                                        <div class="form-group">
                                            <label class="form-label fw-bold" for="qr_sms_phone">Agent Phone</label>
                                            <p style="margin-bottom: 10px;">The number you want people to text if interested.</p>
                                            <input type="text" id="qr_sms_phone" name="name" class="form-control" placeholder="Your Phone Number" v-model="user.qr_sms_phone" required>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label fw-bold" for="qr_sms_message">Text Message</label>
                                            <p style="margin-bottom: 10px;">The message people will automatically text you.</p>
                                            <textarea name="additional_message" id="qr_sms_message" class="form-control" rows="3" placeholder="Text message body..." v-model="qr_details.sms_message" required></textarea>
                                        </div>
                                    </div>
                                    <div v-if="qr_selected === 'qr_call'" id="qr_call_phone">
                                        <div class="form-group">
                                            <label class="form-label fw-bold" for="qr_call_phone">Agent Phone</label>
                                            <p style="margin-bottom: 10px;">The number you want people to call if interested.</p>
                                            <input type="text" name="name" id="qr_call_phone" class="form-control" placeholder="Your Phone Number" v-model="user.qr_call_phone" required>
                                        </div>
                                    </div>
                                    <div v-if="qr_selected === 'qr_email'" id="qr_email">
                                        <div class="form-group">
                                            <label class="form-label fw-bold" for="qr_email_email">Email Address</label>
                                            <input type="email" name="name" id="qr_email_email" class="form-control" v-model="user.qr_email" placeholder="Where would you like info requests to be delivered" required>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label fw-bold" for="qr_email_subject">Subject & Body</label>
                                            <input type="text" name="name" id="qr_email_subject" class="form-control" placeholder="Subject" v-model="qr_details.email_subject" required>
                                        </div>
                                        <div class="form-group">
                                            <textarea name="additional_message" id="qr_email_body" class="form-control" style="height: 5rem;" placeholder="Email body..." v-model="qr_details.email_body" required></textarea>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div class="row">
                                        <h5>Would you like to get a text message when someone scans? </h5><small>Anytime someone scans the QR code, you will get a text message - works for links only.<br><br></small>
                                        <div class="col col-12">
                                            <div style="display: flex; margin-bottom: 10px; align-items: center;">
                                                <Toggle v-model="user.send_qr_scan_notifications" id="qr_scan_notifications" name="qr_scan_notifications" :onLabel="'Yes'" :offLabel="'No'" class="large-toggle"></Toggle>
                                                <input type="tel" class="form-control" name="notification_number" v-model="user.notification_phone" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" style="margin-left: 20px;">
                                            </div>
                                            <div class="form-group" style="display: inline-block; margin-bottom: 0; padding-top: 1px;">
                                                <label class="container_check" style="margin-bottom: 0">Please remind me to use this service when I have new just listed/just sold properties in the future! Please note your number will not be shared with 3rd parties.
                                                    <input type="checkbox" name="send_listing_notifications" v-model="user.send_listing_notifications" >
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="step-action-group">
                                        <button type="button" name="backward" class="_backward" @click="backward">Back</button>
                                        <button type="button" name="forward" class="forward" @click="storeUserUpdates(sendOptIn)" style="margin-left: auto;">Next</button>
                                    </div>
                                    <div style="font-size: 10px; margin-top:15px;">
                                        If you choose to receive text message you hereby consent to receive auto-dialed and/or pre-recorded telemarketing calls and/or text messages on provided number from or on behalf of JustlistedJustSold.com dba thanks.io; from the following telephone number: 845-617-4197, or from other numbers related to or affiliated with the company, which may use an automatic telephone dialing system, an artificial or prerecorded voice or text message. Standard message and data rates may apply.
                                    </div>
                                </div>

                                <div id="pricing" class="step" data-step="send_options">
                                    <h3 class="mb-3">How many cards do you want to send?</h3>
                                    <div class="row">
                                        <span class="alert alert-danger"  v-if="!send_options[audience]">
                                            We couldn't find any mailable addresses near this location in the public records we use. This is common in rural areas and some newer developments where address data isn't yet available. <a href="/">Click Here</a> to try a different listing.
                                        </span>
                                        <div v-if="send_options[audience]" class="col-md-6 col-sm-12 mb-2" v-for="(option) in pricing_options" style="position:relative;">
                                            <button type="button" class="btn w-100" v-bind:class="amount_button_color(option.quantity)" @click="send_amount = parseInt(option.quantity)" :disabled="send_options[audience] < option.quantity">{{ option.quantity }} Cards - ${{ option.price }}/card </button>
                                            <span v-if="parseInt(option.quantity) === 100 && send_options[audience] >= option.quantity" class="badge clickable" :class="send_amount === 100 ? 'bg-light' : 'bg-primary'" style="position:absolute; right: 27px; top: 10px;" :style="{color: send_amount === 100 ? '#0d6efd' : ''}" @click="send_amount = parseInt(option.quantity)">Popular</span>
                                        </div>
                                        <div v-if="send_options[audience]" class="col-md-6 col-sm-12 mb-2">
                                            <div class="dropdown" id="custom_send_amount_dropdown">
                                                <button id="dropdownButtonCustom" class="btn dropdown-toggle w-100" v-bind:class="custom_amount_button_color" type="button"  data-bs-toggle="dropdown" aria-expanded="false">
                                                    {{ show_custom_amount_selected ? send_amount + ' Cards - $' + getCardPrice() + '/card' : 'Select A Custom Amount' }}
                                                </button>
                                                <ul id="custom_amount_dropdown_list" class="dropdown-menu w-100 text-center" aria-labelledby="dropdownButtonCustom">
                                                    <li v-for="amount in available_amounts" class="amount_separator" @click="toggleDropdown('custom_amount_dropdown_list')">
                                                        <a class="dropdown-item" @click="send_amount = amount;">{{ amount }} Cards</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 class="mb-3 mt-5">And to whom?</h4>
                                    <div class="row audience-options">
                                        <div class="col-md-6 col-sm-12">
                                            <div class="audience-option p-2" :class="audience === 'all' ? 'selected' : ''" @click="audience = 'all'">
                                                <h5 class="">Nearest Neighbors</h5>
                                                <p class="mb-0">This will pick the nearest addresses to the listing, most likely to know the home. <strong>(Recommended)</strong></p>
                                                <img :src="s3asset('img/audience/nearest.png', false)" alt="Likely" style="width: 100%;"/>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div class="audience-option p-2" :class="audience === 'likelytomove' ? 'selected' : ''" @click="audience = 'likelytomove'">
                                                <h5>Likely to Sell</h5>
                                                <p class="mb-0">This will pick the nearest addresses with recent life events making them more likely to want to sell.</p>
                                                <img :src="s3asset('img/audience/likely.png', false)" alt="Nearest" style="width: 100%;"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="step-action-group">
                                        <button type="button" name="backward" class="_backward" @click="backward">Back</button>
                                        <button v-if="listing_details.selected_property_type === 'sold' && !has_selected_property" type="button" name="checkout" class="_forward" style="margin-left: auto;" @click="goToCheckout(false)" :disabled="send_to_who_incomplete || going_to_checkout">Checkout!</button>
                                        <button v-else type="button" name="forward" class="_forward" style="margin-left: auto;" @click="forward" :disabled="send_to_who_incomplete">Next</button>
                                    </div>
                                </div>

                                <div id="include_notecard" class="step" data-step="include_notecard">
                                    <div v-if="listing_details.selected_property_type === 'listed'">
                                        <h3>Send The Seller A Review Request Notecard</h3>
                                        <p>
                                            For just a $1.99 extra this handwritten notecard lets you listing now you are grateful for he opportunity to list their
                                            home and more importantly gives them a proof of your just listed postcard showing off your marketing!
                                        </p>
                                        <div>
                                            <img :src="s3asset('img/thanks_cards/listed.png', true)" alt="Notecard Preview" style="width: 100%;"/>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4 col-sm-12">
                                                <label for="seller_name">Seller's Name</label>
                                                <div class="position-relative">
                                                    <input id="seller_name" name="seller_name" type="text" class="form-control" v-model="listing_details.notecard_recipient" :required="require_notecard_address"/>
                                                </div>
                                            </div>
                                            <div class="col-md-8 col-sm-12">
                                                <label>Address</label>
                                                <div class="position-relative">
                                                    <google-autocomplete autocomplete="off"
                                                                         id="notecard_address"
                                                                         name="notecard_address"
                                                                         v-model="listing_details.notecard_address"
                                                                         class="form-control"
                                                                         :value="listing_details.notecard_address"
                                                                         :require_notecard_address="require_notecard_address"
                                                                         @changed="setNotecardAddress"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="listing_details.selected_property_type === 'sold'">
                                        <h3>Send The Seller A Review Request Notecard</h3>
                                        <p>
                                            For just a $1.99 extra we will send a hand written notecard thanking your home seller
                                            for choosing you. more importantly it links a qr code to your zillow review page to generate more reviews.
                                        </p>
                                        <div>
                                            <img :src="s3asset('img/thanks_cards/sold.png', false)" alt="Notecard Preview" style="width: 100%;"/>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4 col-sm-12">
                                                <label for="seller_name">Seller's Name</label>
                                                <div class="position-relative">
                                                    <input id="seller_name" name="seller_name" type="text" class="form-control" v-model="listing_details.notecard_recipient" :required="require_notecard_address"/>
                                                </div>
                                            </div>
                                            <div class="col-md-8 col-sm-12 position-relative">
                                                <label>Address</label>
                                                <div class="position-relative">
                                                    <google-autocomplete autocomplete="off"
                                                                         id="notecard_address"
                                                                         name="notecard_address"
                                                                         v-model="listing_details.notecard_address"
                                                                         class="form-control"
                                                                         :value="listing_details.notecard_address"
                                                                         :require_notecard_address="require_notecard_address"
                                                                         @changed="setNotecardAddress"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="listing_details.selected_property_type === 'leads'">
                                        <h3>Want to Add an Even More Personal Touch?</h3>
                                        <p>
                                            For just a $1.99 per handwritten notecard you can add a second touch to your campaign.<br/>
                                            You can use our default message or customize it to fit your marketing demographic.
                                        </p>
                                        <div>
                                            <img :src="s3asset('img/thanks_cards/leads.png', false)" alt="Notecard Preview" style="width: 100%;"/>
                                        </div>
                                        <div class="row">
                                            <div class="col col-md-6 col-sm-12">
                                                <div style="display: flex; flex-direction: row;">
                                                    <label for="leads_qr_code">QR Code</label>
                                                    <div style="display: flex; flex-direction: row; margin-left: auto; align-items: center;">
                                                        <img :src="s3asset('img/logo/pdf-logo.png', false)" alt="Link" style="height: 12px; display: block; margin-left: auto; margin-right: auto;"/>
                                                        <a v-if="leads_notecard_qr_code !== 'SELLERS_GUIDE_PDF'" href="javascript:void(0);" style="margin-left: 5px;" @click="leads_notecard_qr_code = 'SELLERS_GUIDE_PDF'">Use Branded Seller Guide</a>
                                                        <a v-else href="https://images.bannerbear.com/join_pdfs/vWnx7pMb5lqZJGLVmE/2zW4XVRwgmaRJyKPEY/joined.pdf" target="_blank" style="margin-left: 5px;" >Preview Branded Seller Guide</a>
                                                    </div>
                                                </div>
                                                <div class="position-relative">
                                                    <input id="leads_qr_code" name="leads_qr_code" type="text" class="form-control" v-model="leads_notecard_qr_code" placeholder="(Optional)"/>
                                                </div>
                                            </div>
                                            <div class="col col-md-6 col-sm-12">
                                                <label for="leads_qr_code">Send Delay</label>
                                                <div class="position-relative">
                                                    <div class="dropdown">
                                                        <button class="btn btn-light dropdown-toggle w-100" style="height: calc(2.55rem + 2px);" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {{ leads_notecard_delay === 0 ? '# of weeks delayed' : leads_notecard_delay + ' Week' + (leads_notecard_delay > 1 ? 's' : '') }}
                                                        </button>
                                                        <ul class="dropdown-menu w-100 text-center" aria-labelledby="dropdownMenuButton1">
                                                            <li v-for="index in 3" :key="index" class="amount_separator">
                                                                <a class="dropdown-item" @click="leads_notecard_delay = (index)">{{ index }} Week{{index>1?'s':''}}</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col col-12 mt-3">
                                                <label for="leads_notecard_message">Message</label>
                                                <div class="position-relative">
                                                    <textarea id="leads_notecard_message" name="leads_notecard_message" type="text" class="form-control" v-model="leads_notecard_message" placeholder="Write a quick message to your recipients..." rows="4" style="height: unset;"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="listing_details.selected_property_type === 'leads'" class="step-action-group">
                                        <button type="button" name="backward" class="_backward" @click="backward">Back</button>
                                        <button type="button" class="btn btn-light no-thanks" @click="goToLeadsCheckout(false)">No Thanks, Checkout</button>
                                        <button type="button" class="btn btn-primary" @click="goToLeadsCheckout(true)">Yes, Add for $1.99</button>
                                    </div>
                                    <div v-else class="step-action-group">
                                        <button type="button" name="backward" class="_backward" @click="backward">Back</button>
                                        <button type="button" class="btn btn-light no-thanks" @click="goToCheckout(false)">No Thanks, Checkout</button>
                                        <button type="button" class="btn btn-primary" @click="goToCheckout(true)">Yes, Add for $1.99</button>
                                    </div>
                                    <div class="d-sm-block d-md-none mt-5" style="margin-left: -60px; margin-right: -60px; padding: 1rem;">
                                        <div v-if="listing_details.selected_property_type === 'listed'" style="width: 100%;">
                                            <img :src="s3asset('img/examples/listed-notecard.png', false)" alt="Listed Notecard Message" style="width: 100%; filter: drop-shadow(0px .1rem .2rem #4F4F4F);"/>
                                        </div>
                                        <div v-else style="width: 100%;">
                                            <img :src="s3asset('img/examples/sold-notecard.png', false)"  alt="Sold Notecard Message" style="width: 100%; filter: drop-shadow(0px .1rem .2rem #4F4F4F);"/>
                                        </div>
                                        <p class="mt-4 text-center">Please note: The actual card will have your info.</p>
                                    </div>
                                </div>

                                <div id="thanks" class="step" data-step="thanks">
                                    <h3>Thanks For Your Order!</h3>
                                    <p>
                                        All our postcards are printed next day and shipped USPS first class as to arrive
                                        as fast as possible. You will receive an email confirmation shortly with your order details.
                                    </p>
                                    <p>
                                        <strong>If you haven't created a <a href="https://www.thanks.io" target="_blank">www.thanks.io</a> account before we created one for you (and emailed invite) so you can track your order inside the platform.</strong>
                                    </p>
                                    <p>
                                        <button type="button" name="backward" class="_backward" @click="goHome">Send Another Card</button>
                                    </p>
                                    <div style="margin-top: 5rem;">
                                        <h5>Earn 50 FREE postcards by referring a friend!</h5>
                                        <p style="margin-bottom: 10px;">Refer as many friends as you can and earn 50 free cards per person when they send themselves.</p>
                                        <div class="form-group" style="margin-bottom: 2rem;">
                                            <vue3-tags-input :tags="referrals" placeholder="Enter your friends emails to invite them!" class="invite-input" add-tag-on-blur="true" @on-tags-changed="handleReferralsChange"/>
                                            <div class="mt-3" style="display: flex; align-items: center;">
                                                <button type="button" class="btn btn-jljs" @click="referFriends" :disabled="disable_referral_button">Send Invite Email</button>
                                                <span v-if="referred" class="text-success" style="margin-left: 1rem;">{{ referred }} invites sent!</span>
                                            </div>
                                        </div>
                                        <img :src="s3asset('img/thanks-logo-full.svg', false)" alt="Thanks.io" style="height: 90px;"/>
                                        <p>
                                           Just listed Just Sold is a service of <a href="https://www.thanks.io" target="_blank">thanks.io</a>. If you are looking to build automated direct mail
campaigns please head over to <a href="https://www.thanks.io" target="_blank">https://www.thanks.io</a> to send your first $10 FREE.
                                        </p>
                                        <a href="https://www.thanks.io" target="_blank" >
                                            <img :src="s3asset('img/thanks-send-types.png', true)" alt="Send Types" style="height: 90px;"/>
                                        </a>
                                    </div>
                                    <p style="font-size: 9px; margin-top: 5rem;">
                                        If you choose to receive text messages you hereby consent to receive auto-dialed and/or pre-recorded
                                        telemarketing calls and/or text messages on provided number from or on behalf of JustlistedJustSold.com
                                        dba thanks.io; from the following number: 845-617-4197, or from other numbers related to or affiliated
                                        with the company, which may use an automatic telephone dialing system, an artificial or prerecorded
                                        voice or text message. Standard message and data rates may apply.
                                    </p>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div v-if="step !== 'agent_search' && step != 'template_select'" style="">
                        <img :src="s3asset('img/logo/jljs-thanks-logo.png', true)" alt="Just List Just Sold Postcards" style="height: 35px;"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Leads Front Preview Modal -->
        <div class="modal fade" id="leadsPreviewModal" tabindex="-1" role="dialog" aria-labelledby="termsLabel" aria-hidden="true" style="">
            <div class="modal-dialog modal-dialog-centered" style="max-height: 90vh; max-width: 97vw; justify-content: center; aspect-ratio: 4/3">
                <div class="modal-content" style="">
                    <div class="modal-body" style="">
                        <div style="background-size: cover; aspect-ratio: 1875/1275; background-position: center;" :style="card_leads_styles"></div>
                    </div>
                    <div class="modal-footer">
                        <p style="margin-right: 5rem; font-size: 1.5rem;">This is <strong>EXACTLY</strong> how the front of your card will print.</p>
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ leads_side_incomplete ? leads_render_status : 'Continue Editing' }}</button>
                        <button v-if="!leads_side_incomplete" type="button" class="btn_1" data-bs-dismiss="modal" @click="forward(); renderReviewSide();">Confirm</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->

        <!-- Listed Front Preview Modal -->
        <div class="modal fade" id="propertyPreviewModal" tabindex="-1" role="dialog" aria-labelledby="termsLabel" aria-hidden="true" style="">
            <div class="modal-dialog modal-dialog-centered" style="max-height: 90vh; max-width: 97vw; justify-content: center; aspect-ratio: 4/3">
                <div class="modal-content" style="">
                    <div class="modal-body" style="">
                        <div style="background-size: cover; aspect-ratio: 1875/1275; background-position: center;" :style="card_property_styles"></div>
                    </div>
                    <div class="modal-footer">
                        <div style="margin-right: 5rem; font-size: 1.4rem;">This is <strong>EXACTLY</strong> how the front of your card will print.</div>
                        <div>
                          <button type="button" class="btn btn-outline-secondary" style="margin-right: 10px"  data-bs-dismiss="modal">{{ property_side_incomplete ? property_render_status : 'Continue Editing' }}</button>
                          <button v-if="!property_side_incomplete" type="button" class="btn_1" data-bs-dismiss="modal" @click="forward(); renderReviewSide();">Confirm</button>
                      </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->

        <!-- Review Preview Modal -->
        <div class="modal fade" id="reviewPreviewModal" tabindex="-1" role="dialog" aria-labelledby="termsLabel" aria-hidden="true" style="">
            <div class="modal-dialog modal-dialog-centered" style="max-height: 90vh; max-width: 97vw; justify-content: center; aspect-ratio: 4/3">
                <div class="modal-content" style="">
                    <div class="modal-body" style="">
                        <div style="background-size: cover; aspect-ratio: 1875/1275; background-position: center;" :style="card_review_styles"></div>
                    </div>
                    <div class="modal-footer">
                        <div style="margin-right: auto; font-size: 1.4rem;">This is <strong>EXACTLY</strong> how the back of your card will print.</div>
                        <div>
                          <button type="button" class="btn btn-outline-secondary" style="margin-right: 10px" data-bs-dismiss="modal">{{ review_side_incomplete ? review_render_status : 'Continue Editing' }}</button>
                          <button v-if="!review_side_incomplete" type="button" class="btn_1" data-bs-dismiss="modal" @click="forward();">Confirm Preview</button>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
    </div>
</template>

<script>

import vSelect from "vue-select";
import Toggle from "@vueform/toggle";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import {debounce, isEmpty, parseInt, random, trimStart, merge} from "lodash";
import QrcodeVue from "qrcode.vue";
import TemplateRow from "./components/TemplateRow.vue";
import ZillowProfileSearch from "./components/ZillowProfileSearch.vue"
import InstructionsCarousel from "./InstructionsCarousel.vue";
import GoogleAutocomplete from "./GoogleAutocomplete.vue";
import Vue3TagsInput from 'vue3-tags-input';
import ls from 'localstorage-slim';


// outside the component:
function initialUserState (){
    return {
        // Order Options
        affiliate_code: null,
        audience: 'all',
        available_amounts: [],
        include_thank_you: false,
        require_notecard_address: false,
        require_leads_notecard_delay: false,
        selected_review: null,
        send_amount: 0,
        send_options: {
            all: 0,
            likelytomove: 0
        },

        // User Data
        user: {
            user_hash: null,
            name: null,
            state: null,
            profile_url: null,
            phone: null,
            image: null,
            zillow_id: null,
            agency_broker: null,
            email: null,
            qr_call_phone: null,
            qr_sms_phone: null,
            qr_email: null,
            profile_image_url: null,
            team_logo_url: null,
            broker_logo_url: null,
            disclaimer: null,
            notification_phone: null,
            send_listing_notifications: true,
            send_qr_scan_notifications: true,
            company: null
        },

        // Listing Data
        listing_details: {
            address: {
                line_1: '',
                line_2: ''
            },
            description: '',
            property_image: '',
            custom_message: '',
            call_to_action: 'Call or Text Me',
            selected_property_url: '',
            notecard_recipient: '',
            notecard_address: '',
            selected_property_type: 'listed',
        },

        // Leads Data
        custom_leads_background: null,
        leads_image_filename: 'Template Default',
        leads_notecard_qr_code: 'SELLERS_GUIDE_PDF',
        leads_notecard_delay: 1,
        leads_notecard_message: "A few weeks ago I sent you a card about %ADDRESS%...There has been a good amount of activity around similar listings and I think it would sell pretty fast. If you're at all considering a sale, please text me at %PHONE%.\n\nPlease scan the QR code to download a free whitepaper with everything you need to know to prepare your house for a sale.\n\nCan't wait to talk!\n%FULL_NAME%",
        include_leads_notecard: false,

        // QR Info
        qr_selected: 'qr_link',
        qr_details: {
            email_subject: '',
            email_body: '',
            link: '',
            sms_message: ''
        },

        for_sale_listings: [],
        zillow_reviews: [],
        sold_listings: [],
        default_review: {
            is_custom_message: true,
            overall_rating: 0,
            name: 'Custom Message',
            review_body: 'Select this option to write a custom message to your recipients.'
        },

        // Display Flags
        property_rendering: false,
        sellers_guide_rendering: false,
        downloading_property_data: false,
        disable_referral_button: false,
        going_to_checkout: false,
        enter_zillow_url: false,
        hide_price: false,
        saved_description: '',

        // Display Info
        property_image_filename: 'No file chosen',
        agent_photo_filename: 'No file chosen',
        team_logo_filename: 'No file chosen (optional)',
        broker_logo_filename: 'No file chosen (optional)',

        // Error Flags
        zillow_profile_error: false,
        incorrect_user: false,
        zillow_data_loading: true,

        // Referrals
        referrals: [],
        referred: 0
    }
}

export default {
    components: {
        InstructionsCarousel,
        GoogleAutocomplete,
        vSelect,
        Toggle,
        QrcodeVue,
        Vue3TagsInput,
        TemplateRow,
        ZillowProfileSearch,
    },

    data() {
        let app_data = {
            canvas: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            ip_state: '',
            states: [{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}],
            wizard: null,
            year: new Date().getFullYear(),

            lowest_price: window.data.lowest_price,
            pricing: window.data.pricing,
            whitelabel: window.data.whitelabel,

            step: '',
            first_step: 'template_select',
            editor_previous_step: 'template_select',

            selected_property_template: 1,
            selected_lead_template: 1,
            template_was_picked: false,

            axios_abort_controller: null,

            // Image Data
            card_property_styles: { backgroundImage: 'url(' + this.s3asset('img/examples/listed-1.png', true) + ')', margin: 'unset' },
            card_leads_styles: { backgroundImage: 'url(' + this.s3asset('img/examples/leads-1.png', true) + ')', margin: 'unset' },
            card_review_styles: { backgroundImage: 'url(' + this.s3asset('img/examples/review.png', true) +')', margin: 'unset' },
            pip_large: this.s3asset('img/examples/review.png', true),
            pip_small: this.s3asset('img/examples/listed-1.png', true),
        }

        return Object.assign({}, app_data, initialUserState());
    },

    created() {
    },

    mounted() {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrf;

        ls.config.encrypt = true;
        this.step = this.first_step;
        this.init();
    },

    watch: {
        selected_property_template() {
            this.renderPropertySide();
        },

        hide_price() {
            if(this.hide_price) {
                this.saved_description = this.listing_details.description;
                this.listing_details.description = 'Scan QR on Rear for Pics & Price';
            } else {
                this.listing_details.description = this.saved_description;
            }
        },

        selected_lead_template() {
            this.renderLeadsSide();
        },

        selected_review() {
            if(this.selected_review && this.step === 'review_preview') {
                this.renderReviewSide();
            }
        },

        send_options: {
            deep: true,
            handler(n, o) {
                this.calculateAvailableAmounts()
            }
        },

        audience() {
            this.send_amount = 0;
            this.calculateAvailableAmounts()
        },

        step() {
            try {
                if(this.step == 'agent_search') {
                    clicky.goal('2954');
                } else if(this.step == 'property_select') {
                    clicky.goal('2955');
                } else if(this.step == 'property_preview') {
                    clicky.goal('2956');
                } else if(this.step == 'review_preview') {
                    clicky.goal('2964');
                } else if(this.step == 'qr_code') {
                    clicky.goal('2957');
                } else if(this.step == 'send_options') {
                    clicky.goal('2958');
                } else if(this.step == 'include_notecard') {
                    if (this.listing_details.selected_property_type === 'leads') {
                        // replace variables in leads_notecard_message
                        let message = this.leads_notecard_message;
                        message = message.replace(/%ADDRESS%/g, this.listing_details.address.line_1);
                        message = message.replace(/%PHONE%/g, this.user.phone);
                        message = message.replace(/%FULL_NAME%/g, this.user.name);
                        this.leads_notecard_message = message;
                    }
                    clicky.goal('2959');
                } else if(this.step == 'thanks') {
                    clicky.goal('2960', (1.09 * this.send_amount).toString() );
                }
            } catch(err) {
                console.log(err);
            }

            if(this.step == 'qr_code') {
                this.pingSearch();
            }
        }
    },

    computed: {
        custom_amount_button_color() {
            let quantities = this.pricing_options.map(option => option.quantity);

            if(quantities.includes(this.send_amount)) {
                return {'btn-light': true};
            } else if (this.send_amount > 0 && !quantities.includes(this.send_amount)) {
                return {'btn-primary': true};
            } else {
                return {'btn-light': true};
            }
        },

        show_custom_amount_selected() {
            return this.send_amount > 0 && !this.pricing_options.map(option => option.quantity).includes(this.send_amount);
        },

        property_side_incomplete: function() {
            return (this.property_rendering || !this.user.name || !this.listing_details.property_image || !this.listing_details.description || !this.listing_details.address.line_1 || !this.listing_details.address.line_2);
        },

        leads_side_incomplete: function() {
            return (this.property_rendering || !this.user.name || !this.user.profile_image_url || !this.listing_details.address.line_1 || !this.listing_details.address.line_2);
        },

        has_selected_property: function() {
            return !isEmpty(this.listing_details.selected_property_url);
        },

        send_to_who_incomplete: function() {
            return this.send_amount == 0;
        },

        property_render_status: function() {
            if(this.property_rendering) {
                return 'Generating Preview';
            } else if(this.property_side_incomplete) {
                return 'Please Fill Out All Fields';
            } else {
                return 'Confirm Preview';
            }
        },

        leads_render_status: function() {
            if(this.property_rendering) {
                return 'Generating Preview';
            } else if(this.leads_side_incomplete) {
                return 'Please Fill Out All Fields';
            } else {
                return 'Confirm Preview';
            }
        },

        review_side_incomplete: function() {
            let post_data = this.getReviewPostData();

            let email_re = /\S+@\S+\.\S+/;
            if(this.user.email && !email_re.test(this.user.email)) {
                return true;
            }

            if(this.listing_details && this.listing_details.call_to_action && this.listing_details.call_to_action.includes('REPLACE_THIS_WITH_YOUR_PHONE')) {
                return true;
            }

            return (this.property_rendering || !this.user.email || !this.user.phone || !this.user.company || !this.listing_details.call_to_action || !this.user.disclaimer || !this.user.profile_image_url || (isEmpty(post_data) && !this.listing_details.custom_message));
        },

        review_render_status: function() {
            if(this.property_rendering) {
                return 'Generating Preview';
            } else if(this.review_side_incomplete) {
                return 'Please Fill Out All Fields';
            } else {
                return 'Confirm Preview';
            }
        },

        show_instructions() {
            return ['agent_search', 'property_select', 'template_select'].includes(this.step);
        },

        show_custom_message_input() {
            let show_custom_message_input = this.selected_review?.hasOwnProperty('is_custom_message') ? this.selected_review.is_custom_message : false;
            if(this.reviews.length == 1) {
                show_custom_message_input = true;
            }

            if(!show_custom_message_input){
                this.listing_details.custom_message = '';
            }

            return show_custom_message_input;
        },

        reviews() {
            this.zillow_reviews.push(this.default_review);

            return this.zillow_reviews;
        },

        post_data() {
            let data = {
                user_hash: this.user.user_hash,
                selected_property_template: this.selected_property_template,
                listing_details: this.listing_details,
                hide_price: this.hide_price,
                include_thank_you: this.include_thank_you,
                notecard_address: this.listing_details.notecard_address,
                qr_code: this.buildQRCodeString(),
                review: this.getReviewPostData(),
                send_options: {
                    audience: this.audience,
                    amount: this.send_amount
                },
            };

            // return data;
            return JSON.stringify(data);
        },

        pricing_options() {
            if (isEmpty(this.pricing)) {
                return [];
            }

            let aa = [];
            let pricing_array = Object.entries(this.pricing);
            let available = this.send_options[this.audience];

            pricing_array.forEach((option, key) => {
                let previous = pricing_array[key - 1];
                let [quantity, price] = option;
                quantity = parseInt(quantity);
                if (quantity < available) {
                    aa.push({
                        quantity,
                        price,
                        disabled: false
                    });
                } else if (quantity >= available && (previous === undefined || (parseInt(previous[0]) < available))) {
                    aa.push({
                        quantity: available,
                        price: previous === undefined ? price : previous[1],
                        disabled: false
                    });
                } else {
                    aa.push({
                        quantity,
                        price,
                        disabled: true
                    })
                }
            });

            return aa;
        },

        disable_notecard_checkout() {
            return isEmpty(this.listing_details.notecard_address) || isEmpty(this.listing_details.notecard_recipient);
        }
    },

    methods: {
        //--- Initialization ---\\
        async init() {
            await this.initPlugins();

            if (!window.data.hasOwnProperty('step') || (window.data.hasOwnProperty('step') && window.data.step !== 'thanks')) {
                this._debug('Init State');

                this.initStateSelect();
                this.initUser();

                try {
                    LeadDyno.recordVisit(function() {  });
                } catch (error) {
                    this._debug("Error: ", error);
                }
            }
        },

        async initPlugins() {
            this.initNiceSelect();
            this.initContactPicker();

            // Set affiliate code
            let query_params = new URLSearchParams(window.location.search);
            if (query_params.get('afmc')) {
                this.affiliate_code = query_params.get('afmc');
            }

            let firstStep = this.step;
            if (window.data !== undefined && window.data.step !== undefined) {
                firstStep = window.data.step;
            }

            //init wizard
            $("#wizard_container").wizard({
                stepsWrapper: "#wrapped",
                submit: ".submit",
                initialStep: firstStep,
                beforeSelect: function (event, state) {
                    if ($('input#website').val().length != 0) {
                        return false;
                    }
                    if (!state.isMovingForward)
                        return true;
                    let inputs = $(this).wizard('state').step.find(':input');
                    return !inputs.length || !!inputs.valid();
                }
            }).validate({
                errorPlacement: function (error, element) {
                    if (element.is(':radio') || element.is(':checkbox')) {
                        error.insertBefore(element.next());
                    } else {
                        error.insertAfter(element);
                    }
                }
            });
            this.wizard = $('#wizard_container');
            this.wizard.wizard().bind('wizardafterselect', this.setCurrentStep);
        },

        initNiceSelect() {
            let self = this;
            let qr_type_select = $('#qr_type_select');
            qr_type_select.niceSelect();
            qr_type_select.on('change', function (event) {
                self.qr_selected = $(event.target).val();
            });

            let review_select = $('#review_select');
            review_select.niceSelect();
        },

        async initContactPicker() {
            const supported = ('contacts' in navigator && 'ContactsManager' in window);
            if (!supported) {
                return;
            }

            const props = ['email'];
            const opts = {multiple: true};

            try {
                // const contacts = await navigator.contacts.select(props, opts);
                const contacts = this.getContacts();
                this.referrals = contacts.reduce((referrals, contact) => {
                    if (contact.email[0] !== undefined) {
                        referrals.push(contact.email[0])
                    }

                    return referrals;
                }, []);
            } catch (ex) {
                // Handle any errors here.
                this.referrals = [];
            }
        },

        initStateSelect() {
            let self = this;
            axios.get('https://ipinfo.io/json').then(response => {
                self.ip_state = response.data.region;
                self.user.state = response.data.region;
            })
           .catch(error => {console.log('error: ', error)});
        },

        initUser() {
            let self = this;

            let query_params = new URLSearchParams(window.location.search);
            if (query_params.get('name') && query_params.get('state')) {
                this.user.name = query_params.get('name');
                this.user.state = query_params.get('state');
                this.createOrLoginUser(false);
                this.goToStep('property_select');
                return;
            }

            axios.get('/api/users/me')
                .then(response => {
                    let user = response.data.user;
                    self.user = user;
                    if(!self.user.state && self.ip_state) {
                        self.user.state = self.ip_state;
                    }

                    if (isEmpty(user.user_hash)) {
                        return;
                    }

                    if (!isEmpty(user.profile_url)) {
                        self.getZillowProfileData(false);
                        $('#agent_search_name').val(user.name);
                        self.goToStep('property_select');
                    }
                })
                .catch(error => {
                    self._debug("Init User Error: ", error);
                });
        },

        //--- User Creation / Authentication ---\\
        createOrLoginUser(validate = true) {
            if (validate) {
                let inputs = this.wizard.wizard('state').step.find(':input');
                if (!(!inputs.length || !!inputs.valid())) {
                    this._debug("Invalid");
                    return;
                }
            }

            let self = this;
            this.zillow_data_loading = true;
            this.clearErrors();

            // Only search by name, state
            this.goToStep('property_select');
            let url = '/api/users';
            axios.post(url, {
                name: self.user.name,
                state: self.user.state
            })
                .then(response => {
                    // Refresh All Wizard Data
                    let previous_selected_property_type = self.listing_details.selected_property_type;
                    Object.assign(self.$data, initialUserState());
                    self.listing_details.selected_property_type = previous_selected_property_type;

                    let user = response.data.user;
                    self.user = user;

                    if (isEmpty(user.profile_url)) {
                        self.searchForZillowProfileUrl();
                    } else {
                        self.getZillowProfileData(false);
                    }
                })
                .catch(error => {
                    console.log("Error: ", error);
                })
        },

        createGuestUser() {
            let self = this;
            // Only search by name, state
            console.log(self.user);
            console.log( {
                name: self.user.name,
                state: self.user.state

            });
            let url = '/api/users/guest';
            axios.post(url, {
                name: self.user.name,
                state: self.user.state
            })
                .then(response => {
                    // Refresh All Wizard Data
                    let user = response.data.user;
                    self.user = user;
                })
                .catch(error => {
                    console.log("Error: ", error);
                })
        },

        createOrLoginUserViaZillowUrl(profile_url) {
            let self = this;
            self.goToStep('property_select');
            this.user.profile_url = profile_url;
            this.zillow_data_loading = true;
            this.clearErrors();

            let previous_state = '';
            if(self.user && self.user.state) {
              previous_state = self.user.state;
            }

            // Only search by name, state
            let url = '/api/users';
            axios.post(url, {
                zillow_profile_url: this.user.profile_url,
                state: previous_state
            })
                .then(response => {
                    // Refresh All Wizard Data
                    let previous_selected_property_type = self.listing_details.selected_property_type;
                    Object.assign(self.$data, initialUserState());
                    self.listing_details.selected_property_type = previous_selected_property_type;

                    let user = response.data.user;
                    self.user = user;
                    self.getZillowProfileData(true);
                })
                .catch(error => {
                    console.log("Error: ", error);
                })
        },

        storeUserUpdates(callback=null) {
            let self = this;
            if(!this.user.user_hash) {
                this.createGuestUser();
                return;
            }

            let url = '/api/users/' + this.user.user_hash;
            let params = this.user;

            axios.put(url, params).then((response) => {
                self.user = response.data.user;

                if(self.agent_photo_filename == 'No file chosen' && self.user.profile_image_url) {
                    self.agent_photo_filename = 'Account Default';
                }
                if(self.team_logo_filename == 'No file chosen (optional)' && self.user.team_logo_url) {
                    self.team_logo_filename = 'Account Default';
                }
                if(self.broker_logo_filename == 'No file chosen (optional)' && self.user.broker_logo_url) {
                    self.broker_logo_filename = 'Account Default';
                }

                if(callback && typeof callback === 'function') {
                    callback();
                }
            });
        },

        sendOptIn() {
            axios.get('/api/users/send_opt_in');
        },


        searchForZillowProfileUrl() {
            this._debug('searchForZillowProfileUrl');

            let self = this;
            this.zillow_data_loading = true;

            // Only search by name, state
            let url = '/api/zillow/search/profile';
            axios.post(url, {
                name: self.user.name,
                state: self.user.state
            })
                .then(response => {
                    let user = response.data.user;
                    self.user = user;

                    if (!isEmpty(user.profile_url)) {
                        self.getZillowProfileData(false);
                        return;
                    } else {
                        self.incorrect_user = true;
                        self.zillow_data_loading = false;
                    }
                })
                .catch(error => {
                    console.log("Error: ", error);
                    self.incorrect_user = true;
                    self.zillow_profile_error = true;
                    self.zillow_data_loading = false;
                })
        },

        getZillowProfileData(bustcache) {
            this._debug('getZillowProfileData');
            let self = this;

            let profile_url = this.user.profile_url;
            if(!profile_url) {
                return;
            }

            this.editor_previous_step = 'property_select';
            this.zillow_data_loading = true;
            this.clearErrors();

            let api_url = '/api/zillow/data/profile';
            axios.post(api_url, {
                profile_url, bustcache
            })
                .then(response => {
                    self._debug(response);

                    if(!response.data.errors) {
                        self.setProfileData(response.data.zillow, response.data.user);
                    } else {
                        self.incorrect_user = true;
                        self.zillow_profile_error = true;
                        self.selected_review = this.default_review;
                        self.user.profile_url = "";
                    }
                    this.zillow_data_loading = false;
                    this.checkMissingListings();
                })
                .catch(error => {
                    self._debug("getZillowProfileData Error: ", error);
                    self.incorrect_user = true;
                    self.zillow_profile_error = true;

                    self.zillow_data_loading = false;
                    self.selected_review = this.default_review;
                    this.checkMissingListings();
                    self.user.profile_url = "";
                });
        },

        clearErrors() {
            this.zillow_profile_error = false;
            self.incorrect_user = true;
        },

        setProfileData(listing_details, user_data) {
            this.agent_photo_filename = 'No file chosen';
            this.broker_logo_filename = 'No file chosen (optional)';
            this.user = user_data;

            this.for_sale_listings = listing_details.for_sale;
            this.sold_listings = listing_details.sold;

            this.zillow_reviews = listing_details.reviews;
            this.selected_review = this.zillow_reviews[0];
            if (isEmpty(this.zillow_reviews)) {
                this.selected_review = this.default_review;
            }
        },

        checkMissingListings() {
            if(!this.for_sale_listings.length && !this.sold_listings.length) {
                this.zillow_profile_error = true;

                if(this.template_was_picked) {
                    // Template was previously selected
                    this.goToStep('property_preview');
                } else {
                    this.goToStep(this.first_step);
                }
            }
        },

        //--- Property Selection ---\\
        selectProperty(property, property_type) {
            this.listing_details.selected_property_type = property_type;

            if (!isEmpty(property)) {
                this.listing_details.selected_property_url = 'https://zillow.com/' + trimStart(property.listing_url, '/');
                this.listing_details.address.line_1 = property.address_line1;
                this.listing_details.address.line_2 = property.address_line2;
                let phone = this.user.phone;
                if (!phone && this.user.profile_url) {
                    phone = 'REPLACE_THIS_WITH_YOUR_PHONE';
                }
                this.listing_details.call_to_action = 'Text \'' + this.listing_details.address.line_1 + '\' to ' + phone + ' for more info!';
                this.listing_details.property_image = property.image_url;
                this.listing_details.property_image = property.image_url;
                if (this.listing_details.property_image) {
                    this.property_image_filename = 'Listing Image';
                }
                this.listing_details.description = property.description;
            } else {
                if (property_type === 'sold') {
                    this.card_property_styles.backgroundImage = 'url(' + this.s3asset('img/examples/sold-1.png', true) + ')';
                }
            }

            this.setDataForProperty();
            this.forward();
        },

        async setDataForProperty() {
            let self = this;

            if (isEmpty(this.listing_details.address.line_1) || isEmpty(this.listing_details.address.line_2)) {
                console.log("Not all address fields are filled out. Can't get send data.");
                return;
            }

            let address = this.listing_details.address.line_1;
            this.qr_details.link =  this.listing_details.selected_property_url;
            if (this.listing_details.selected_property_type === 'leads') {
                this.qr_details.link = 'SELLERS_GUIDE_PDF';
            } else if(this.listing_details.property_type == 'sold') {
                this.listing_details.notecard_address = '';
                this.qr_details.sms_message = "Hi! I'm neighbors with " + address + " and am interested in my homes value.";
                this.qr_details.email_subject = "Neighbors with " + address;
                this.qr_details.email_body = "Hi!\n\nI'm neighbors with " + address + " and I'd be interested in you coming out and potentially listing our home.";
            } else {
                this.listing_details.notecard_address = this.listing_details.address.line_1 + ' ' + this.listing_details.address.line_2;
                this.qr_details.sms_message = "Hi! I'm interested in more information on " + address;
                this.qr_details.email_subject = "More info on " + address;
                this.qr_details.email_body = "Hi!\n\nI saw your mailing and would like more information on " + address;
            }

            this.renderPropertySide();

            address += ' ' + this.listing_details.address.line_2;
            let url = '/api/recipient_count';
            axios.post(url, {address, recipient_type: 'all'})
                .then(response => {
                    self.send_options.all = response.data.recipient_count || 0;
                })
                .catch(error => {console.log('error: ', error)});

            axios.post(url, {address, recipient_type: 'likelytomove'})
                .then(response => {
                    self.send_options.likelytomove = response.data.recipient_count || 0;
                })
                .catch(error => {console.log('error: ', error)});
        },

        // TODO: pipe the auto-complete address into the google places api
        autocompleteInput($event) {
            this.listing_details.address.line_1 = $event.target.value;
            // const autocomplete = new google.maps.places.Autocomplete($event.target);
        },

        onPropertyAddressInput(address) {
            if (isEmpty(address)) {
                return;
            }

            this._debug(address);

            let street_number = (address.street_number !== undefined) ? address.street_number.short_name: '';
            let route = (address.route !== undefined) ? address.route.short_name : '';
            let locality = (address.locality !== undefined) ? address.locality.long_name : '';
            if(!locality) {
                locality = (address.sublocality_level_1 !== undefined) ? address.sublocality_level_1.long_name : '';
            }
            if(!locality) {
                locality = (address.neighborhood !== undefined) ? address.neighborhood.long_name : '';
            }

            let province = '';
            if(address.administrative_area_level_1 !== undefined) {
                if(address.administrative_area_level_1.short_name.length == 1) {
                    province = address.administrative_area_level_1.long_name;
                } else {
                    province = address.administrative_area_level_1.short_name;
                }
            }
            let postal_code = (address.postal_code !== undefined) ? address.postal_code.long_name : '';

            this.listing_details.address.line_1 = street_number + " " + route;
            this.listing_details.address.line_2 = locality + ', ' + province + ' ' + postal_code;

            this.setDataForProperty();
        },

        renderPropertySide() {
            this.clearErrors();
            if(!this.downloading_property_data) {
                this.cancel_previos_renders();
                this.property_rendering = true;
                let callback = this.listing_details.selected_property_type === 'leads' ? this.performLeadsSideRender : this.performPropertySideRender;
                this.storeUserUpdates(callback);
            }
        },

        performPropertySideRender() {
            let self = this;
            let url = '/api/generate/property';
            let params = {
                template: this.selected_property_template,
                listing_details: this.listing_details
            };

            axios.post(url, params, {signal: self.axios_abort_controller.signal})
                .then(response => {
                    self.pip_small = response.data.property_side_image_urls.image_url;
                    self.card_property_styles.backgroundImage = 'url(' + response.data.property_side_image_urls.image_url + ')';
                    self.property_rendering = false;
                })
                .catch(error => {
                    if(error.message != 'canceled') {
                        this._debug("Error: ", error);
                        self.property_rendering = false;
                        if(this.listing_details.property_image) {
                            // Remove image and try again
                            this.listing_details.property_image = '';
                            this.property_image_filename = 'No file chosen';
                            this.renderPropertySide();
                        };
                    }
                })
        },

        //--- Review Side ---\\
        renderReviewSide() {
            if(this.listing_details && this.listing_details.call_to_action && this.listing_details.call_to_action.includes('REPLACE_THIS_WITH_YOUR_PHONE')) {
                if(this.user.phone) {
                    let phone = this.user.phone;
                    // Format as xxx-xxx-xxxx
                    const digits = phone.replace(/\D/g, '');
                    if (digits.length === 10) {
                        phone = digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
                    }

                    if(phone) {
                        this.listing_details.call_to_action = this.listing_details.call_to_action.replace('REPLACE_THIS_WITH_YOUR_PHONE', phone);
                    }
                }
            }

            this.cancel_previos_renders();
            this.property_rendering = true;
            this.storeUserUpdates(this.performReviewSideRender);
        },

        performReviewSideRender() {
            let self = this;
            this.cancel_previos_renders();
            this.property_rendering = true;

            let url = '/api/generate/review';
            let review = this.getReviewPostData();
            let qr_code = this.buildQRCodeString();
            let custom_message = null;
            if (isEmpty(review)) {
                custom_message = !isEmpty(this.listing_details.custom_message) ? this.listing_details.custom_message : '';
            }

            let params = {
                hide_price: this.hide_price,
                custom_message,
                review,
                listing_details: self.listing_details,
                qr_code: !isEmpty(qr_code) ? qr_code : 'https://justlistedjustsold.com',
            };

            axios.post(url, params, {signal: self.axios_abort_controller.signal})
                .then(response => {
                    self.property_rendering = false;

                    if (response.data.review_side_image_url === null) {
                        return;
                    }
                    self.pip_large = response.data.review_side_image_url;
                    self.card_review_styles.backgroundImage = 'url(' + response.data.review_side_image_url + ')';
                })
                .catch(error => {
                    if(error.message != 'canceled') {
                        this._debug("Error: ", error);
                        self.property_rendering = false;
                    }
                });
        },

        //--- Render Leads Side ---\\
        renderLeadsSide() {
            this._debug('Rendering Leads Side')
            this.cancel_previos_renders();
            this.property_rendering = true;
            this.storeUserUpdates(this.performLeadsSideRender);
        },

        performLeadsSideRender() {
            this._debug('Performing Leads Side Render')
            let self = this;
            this.cancel_previos_renders();
            this.property_rendering = true;

            let url = '/api/generate/leads';
            let params = {
                type: 'leads',
                template: this.selected_lead_template,
                agent_name: this.user.name,
                agent_headshot: this.user.profile_image_url,
                custom_leads_background: this.custom_leads_background
            };
            this._debug("Lead Params: ", params);

            axios.post(url, params, {signal: self.axios_abort_controller.signal})
                .then(response => {
                    self._debug("Leads Response: ", response);
                    self.property_rendering = false;

                    if (response.data.lead_side_image_url === null) {
                        return;
                    }
                    self.pip_small = response.data.lead_side_image_url;
                    self.card_leads_styles.backgroundImage = 'url(' + response.data.lead_side_image_url + ')';
                })
                .catch(error => {
                    if(error.message != 'canceled') {
                        this._debug("Error: ", error);
                        self.property_rendering = false;
                    }
                });
        },

        //--- Send Options ---\\
        calculateAvailableAmounts() {
            if (this.send_options[this.audience] === 0) {
                return [];
            }

            let range = _.range(50, this.send_options[this.audience] + 1, 50);

            let pricing_array = Object.entries(this.pricing);
            let [quantity, price] = pricing_array[0];
            quantity = parseInt(quantity);

            if (range.length === 0 && this.send_options[this.audience] <= quantity) {
                range.push(this.send_options[this.audience]);
            }

            if (this.send_options[this.audience] < range[0]) {
                range.unshift(this.send_options[this.audience]);
            }

            if (range.length === 0 || this.send_options[this.audience] > range[range.length - 1]) {
                range.push(this.send_options[this.audience]);
            }

            if (quantity < range[0]) {
                range.unshift(quantity);
            }

            this.available_amounts = range;
        },

        //--- Include Notecard ---\\
        setNotecardAddress(address) {
            this.listing_details.notecard_address = address.formatted_address.long_name;
        },

        //--- Checkout ---\\
        getReviewPostData() {
            if ( isEmpty(this.selected_review) ) {
                return {};
            }

            if (this.selected_review.is_custom_message) {
                return {};
            }

            return {
                overall_rating: this.selected_review.overall_rating,
                sub_ratings: this.selected_review.sub_ratings,
                reviewee: {
                    name: this.selected_review.name,
                    work: this.selected_review.work_done
                },
                body: this.selected_review.review_body
            };
        },

        handleReferralsChange(tags) {
            this.referrals = tags;
        },

        referFriends() {
            let self = this;

            this.disable_referral_button = true;

            let url = '/api/referrals';

            let params = {
                referral_emails: this.referrals
            };

            axios.post(url, params)
                .then(response => {
                    self.referred = response.data.referred;
                    self.disable_referral_button = false;
                    self.referrals = [];
                })
                .catch(error => {
                    self.disable_referral_button = false;
                });
        },

        async uploadPropertyImage() {
            // Check if up-scaling is needed
            let file = this.$refs['propertyImage'].files[0];

            //NO IMAGE FILE
            if(!file || file.type.indexOf('image/') !== 0) return;

            this.listing_details.property_image = await this.uploadImage(file);

            if (this.listing_details.property_image !== null) {
                this.property_image_filename = file.name;
                this.renderPropertySide();
            }
        },

        async uploadLeadsImage() {
            let file = this.$refs['leadsImage'].files[0];

            if(!file || file.type.indexOf('image/') !== 0) return;

            this.custom_leads_background = await this.uploadImage(file);

            if (this.custom_leads_background !== null) {
                this.leads_image_filename = file.name;
                this.renderLeadsSide();
            }
        },

        async uploadHeadshotImage() {
            this.user.profile_image_url = await this.uploadImage(this.$refs['agentHeadshot'].files[0]);

            if (this.user.profile_image_url !== null) {
                this.agent_photo_filename = this.$refs['agentHeadshot'].files[0].name;
                this.renderLeadsSide();
            }
        },

        async uploadAgentImage() {
            this.user.profile_image_url = await this.uploadImage(this.$refs['agentImage'].files[0]);

            if (this.user.profile_image_url !== null) {
                this.agent_photo_filename = this.$refs['agentImage'].files[0].name;
                this.renderReviewSide();
            }
        },

        async uploadTeamLogo() {
            this.user.team_logo_url = await this.uploadImage(this.$refs['teamImage'].files[0]);

            if (this.user.team_logo !== null) {
                this.team_logo_filename = this.$refs['teamImage'].files[0].name;
                this.renderReviewSide();
            }
        },

        async uploadBrokerLogo() {
            this.user.broker_logo_url = await this.uploadImage(this.$refs['brokerImage'].files[0]);

            if (this.user.broker_logo !== null) {
                this.broker_logo_filename = this.$refs['brokerImage'].files[0].name;
                this.renderReviewSide();
            }
        },

        async uploadImage(image) {
            let image_url = null;

            await Vapor.store(image, {
                visibility: 'public-read',
                progress: progress => {
                    this.uploadProgress = Math.round(progress * 100);
                }
            }).then(response => {
                image_url = 'https://s3.amazonaws.com/' + response.bucket + '/' + response.key;
            }).catch(error => {
                console.log("Error: ", error.response);
            });

            return image_url;
        },

        //--- Utilities ---\\
        resetPropertyData() {
            let initial_user_state = initialUserState();
            this.hide_price = false;
            this.listing_details = initial_user_state.listing_details;
            this.property_image_filename = initial_user_state.property_image_filename;
        },

        checkPropertyImage(url) {
            if (url.includes('maps.googleapis')) {
                return this.s3asset('img/property_thumbnail_placeholder.png', false);
            }

            return url;
        },

        getPropertyPriceDisplay(price) {
            let units = ['', 'K', 'M', 'B', 'T'];
            let i = 0;
            for (i; price >= 1000; i++) {
                price /= 1000;
            }
            return Math.round(price) + units[i];
        },

        getCardPrice() {
            let pricing_array = Object.entries(this.pricing);
            let [quantity, price] = pricing_array[0];
            quantity = parseInt(quantity);

            if (this.send_amount < quantity) {
                return price;
            }

            let last_price = price;
            pricing_array.forEach((option, key) => {
                [quantity, price] = option;
                quantity = parseInt(quantity);

                if (this.send_amount >= quantity) {
                    last_price = price;
                }
            });

            return last_price;
        },

        amount_button_color(amount) {
            return {
                'btn-primary': this.send_amount === parseInt(amount),
                'btn-light': this.send_amount !== parseInt(amount)
            }
        },

        toggleDropdown(dropdown_id) {
            let dropdown = $('#' + dropdown_id);
            dropdown.removeClass('show');
        },

        toggleModal(modal_id) {
            let modal = $('#' + modal_id);
            modal.modal('toggle');
        },

        confirmLeadsPreview() {
            this.toggleModal('leadsPreviewModal');
        },

        confirmPropertyPreview() {
            this.toggleModal('propertyPreviewModal');
        },

        confirmReviewPreview() {
            this.toggleModal('reviewPreviewModal');
        },

        forward() {
            this.wizard.wizard('forward');
        },
        backward() {
            this.wizard.wizard('backward');
        },
        backwardFromEditor() {
            this.goToStep(this.editor_previous_step);
        },
        loadFromMLS() {
            if(this.for_sale_listings.length || this.sold_listings.length) {
                this.goToStep('property_select');
            } else {
                this.goToStep('agent_search');
            }
        },
        setCurrentStep(event, state) {
            this.step = state.step.data('step') || null;
        },
        goToStep(step) {
            this.wizard.wizard("select", step);
        },
        goToPropertyEditor(property_type, template_id) {
            this.resetPropertyData();

            this.editor_previous_step = 'template_select';

            this.template_was_picked = true;
            this.listing_details.selected_property_type = property_type;
            this.setDataForProperty();

            if(property_type == 'leads') {
                this.card_leads_styles.backgroundImage = 'url(' + this.s3asset('img/examples/' + property_type + '-' + template_id + '.png', true) + ')';
                this.selected_lead_template = template_id;
            } else {
                this.card_property_styles.backgroundImage = 'url(' + this.s3asset('img/examples/' + property_type + '-' + template_id + '.png', true) + ')';
                this.selected_property_template = template_id;
            }

            this.goToStep('property_preview');
        },

        buildQRCodeString() {
            switch (this.qr_selected) {
                case "qr_link":
                    if(this.qr_details.link == 'SELLERS_GUIDE_PDF') {
                        return this.qr_details.link;
                    }

                    let url = decodeURIComponent(this.qr_details.link);
                    if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
                        url = 'https://' + url
                    }
                    return url;
                case "qr_sms":
                    return `SMSTO:${this.user.qr_sms_phone}:${this.qr_details.sms_message}`;
                case "qr_call":
                    return `tel:${this.user.qr_call_phone}`;
                case "qr_email":
                    return `MATMSG:TO:${this.user.qr_email};SUB:${this.qr_details.email_subject};BODY:${this.qr_details.email_body};;`;
                default:
                    return 'https://justlistedjustsold.com';
            }
        },

        goToCheckout(include_thank_you) {
            let self = this;
            this.going_to_checkout = true;
            this.include_thank_you = include_thank_you;
            this.require_notecard_address = include_thank_you;

            //Next tick is so Vue can finish its reactivity update before validating the form and continuing with checkout
            this.$nextTick(() => {
                self.redirectToStripe();
            });
        },

        redirectToStripe() {
            let self = this;
            let url = '/checkout'
            let params = {
                user_hash: this.user.user_hash,
                selected_property_template: this.selected_property_template,
                listing_details: this.listing_details,
                include_thank_you: this.include_thank_you,
                hide_price: this.hide_price,
                notecard_address: this.listing_details.notecard_address,
                qr_code: this.buildQRCodeString(),
                review: this.getReviewPostData(),
                send_options: {
                    audience: this.audience,
                    amount: this.send_amount
                },
                affiliate_code: this.affiliate_code
            };

            let is_valid = $('#wrapped').valid();
            if (!is_valid) {
                this._debug("Invalid: Form cannot be submitted.");
            }

            if(this.include_thank_you && (!this.listing_details.notecard_address || !this.listing_details.notecard_recipient)) {
                return;
            }

            axios.post(url, params)
                .then(response => {
                    if (!isEmpty(response.data.checkout_url)) {
                        window.location.assign(response.data.checkout_url);
                    }
                })
                .catch(error => {
                    self._debug("Error: ", error);
                    self.going_to_checkout = false;
                });
        },

        goToLeadsCheckout(include_leads_notecard) {
            let self = this;
            this.going_to_checkout = true;
            this.include_leads_notecard = include_leads_notecard;
            this.require_leads_notecard_delay = include_leads_notecard;

            //Next tick is so Vue can finish its reactivity update before validating the form and continuing with checkout
            this.$nextTick(() => {
                self.redirectToLeadsStripe();
            });
        },

        redirectToLeadsStripe() {
            let self = this;
            let url = '/checkout/leads'
            let params = {
                user_hash: this.user.user_hash,
                agent: this.user,
                selected_leads_template: this.selected_lead_template,
                custom_leads_background: this.custom_leads_background,
                listing_details: this.listing_details,
                review: this.getReviewPostData(),
                qr_code: this.buildQRCodeString(),
                hide_price: this.hide_price,
                include_leads_notecard: this.include_leads_notecard,
                leads_notecard_qr_code: this.leads_notecard_qr_code,
                leads_notecard_delay: this.leads_notecard_delay,
                leads_notecard_message: this.leads_notecard_message,
                send_options: {
                    audience: this.audience,
                    amount: this.send_amount
                },
                affiliate_code: this.affiliate_code
            };

            let is_valid = $('#wrapped').valid();
            if (!is_valid) {
                this._debug("Invalid: Form cannot be submitted.");
            }

            if(this.include_leads_notecard && (this.leads_notecard_delay === 0)) {
                this._debug("Leads notecard delay is 0");
                return;
            }

            axios.post(url, params)
                .then(response => {
                    if (!isEmpty(response.data.checkout_url)) {
                        window.location.assign(response.data.checkout_url);
                    }
                })
                .catch(error => {
                    self._debug("Error: ", error);
                    self.going_to_checkout = false;
                });
        },

        recordLead() {
            // something funky happened where they're able to submit without all fields being filled out
            if(!this.user.email || this.user.email == 'null') {
                return;
            }

            //TODO: IDK this looks like it's working from the logs but not in the dashboard
            var firstName = this.user.name.split(' ').slice(0, -1).join(' ');
            var lastName = this.user.name.split(' ').slice(-1).join(' ');
            try {
                LeadDyno.recordLead(this.user.email, {first_name: firstName, last_name: lastName, state: this.user.state, company: this.user.company, phone: this.user.phone}, function() {
                });
            } catch (error) {
                this._debug("Error: ", error);
            }

            this.confirmReviewPreview();
        },

        pingSearch() {
            axios.get('/api/users/searched');
        },

        toggleFocusedImage() {
            let l = this.pip_large;
            this.pip_large = this.pip_small;
            this.pip_small = l;
        },

        showLoadedImage(event) {
            !event.target.classList.contains('loaded') ? event.target.classList.add('loaded') : null;
        },

        homeLink() {
            return window.data.whitelabel ? ('/' + window.data.whitelabel) : '/';
        },

        goHome() {
            location.href = this.homeLink();
        },

        s3asset(path, use_whitelabel) {
            if(use_whitelabel) {
                // Call window.data cause this is called when setting up data
                if(window.data.whitelabel) {
                    path = 'whitelabel/' + window.data.whitelabel + '/' + path;
                }
            }
            return this.asset(path);

            // This might be a performance thing - not sure.  Keeping around, but it's more confusing to use ATM
            if(import.meta.env.DEV) {
                return 'https://s3.amazonaws.com/content.justlistedjustsold.com/assets/' + path;
            }

        },

        cancel_previos_renders() {
            if(this.axios_abort_controller) {
                this.axios_abort_controller.abort();
            }
            this.axios_abort_controller = new AbortController();
        },
        // IDK what to do with this function
        _getProgressUpdates() {
            let self = this;

            this.disable_update_button = true;

            let url = '';

            let params = {
                delivery_updates: false,
                du_number: '8163045041',
                new_listed_sold_notifications: true
            };
        },

        _debug(message) {
            if(import.meta.env.DEV) {
                console.log(message);
            }
        }
    }
}

</script>

<style src="@vueform/toggle/themes/default.css"></style>

<style>
.btn:disabled {
    opacity: 0.25;
    cursor: not-allowed;
}
</style>
